import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, CheckCircle2, ArrowRight, Plus } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { PageHeader } from "../components/DashboardLayout";
import { Button } from "../components/ui/button";
import api from "../lib/api";

export default function DashboardHome() {
  const { user } = useAuth();
  const [projects, setProjects] = useState(null);

  useEffect(() => {
    api.get("/api/projects").then(({ data }) => setProjects(data)).catch(() => {});
  }, []);

  const total = projects?.length ?? null;
  const active = projects?.filter((p) => p.is_active).length ?? null;
  const recent = (projects || []).slice(0, 5);

  return (
    <div>
      <PageHeader
        title={`Ciao, ${user?.name?.split(" ")[0] || ""}`}
        subtitle="I tuoi agenti: avatar, flusso, azioni verso API esterne, RAG e strumenti MCP"
      >
        <Link to="/dashboard/projects">
          <Button data-testid="dashboard-new-project-btn">
            <Plus className="h-4 w-4" /> Nuovo progetto
          </Button>
        </Link>
      </PageHeader>

      <div className="p-8">
        <div className="grid gap-4 sm:grid-cols-2" data-testid="stats-grid">
          <div className="border border-line bg-white p-6" data-testid="stat-total">
            <div className="flex items-start justify-between">
              <span className="text-xs font-semibold uppercase tracking-wide text-slate-400">Progetti</span>
              <Sparkles className="h-5 w-5 text-brand" />
            </div>
            <p className="mt-4 font-display text-4xl font-black tracking-tight text-ink">{total ?? "—"}</p>
          </div>
          <div className="border border-line bg-white p-6" data-testid="stat-active">
            <div className="flex items-start justify-between">
              <span className="text-xs font-semibold uppercase tracking-wide text-slate-400">Attivi</span>
              <CheckCircle2 className="h-5 w-5 text-brand" />
            </div>
            <p className="mt-4 font-display text-4xl font-black tracking-tight text-ink">{active ?? "—"}</p>
          </div>
        </div>

        {recent.length > 0 && (
          <div className="mt-8 border border-line bg-white" data-testid="recent-projects">
            <p className="border-b border-line px-6 py-3 text-xs font-semibold uppercase tracking-wide text-slate-400">
              Progetti recenti
            </p>
            <div className="divide-y divide-line">
              {recent.map((p) => (
                <Link
                  key={p.id}
                  to={`/dashboard/projects/${p.id}`}
                  className="flex items-center justify-between px-6 py-3 hover:bg-slate-50"
                  data-testid={`recent-project-${p.id}`}
                >
                  <span className="text-sm font-medium text-ink">{p.name}</span>
                  <ArrowRight className="h-4 w-4 text-slate-300" />
                </Link>
              ))}
            </div>
          </div>
        )}

        {total === 0 && (
          <div className="mt-8 grid-backdrop border border-line bg-white/70 p-10 text-center">
            <Sparkles className="mx-auto h-10 w-10 text-brand" />
            <h3 className="mt-4 font-display text-lg font-bold text-ink">Crea il tuo primo agente</h3>
            <p className="mt-1 text-sm text-slate-500">
              Un progetto = un avatar, un flusso e le azioni/strumenti che vuoi collegare.
            </p>
            <Link to="/dashboard/projects">
              <Button className="mt-5" data-testid="dashboard-empty-new-project-btn">
                <Plus className="h-4 w-4" /> Nuovo progetto
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
